/**
 * HTTP client for Group Inbox configuration APIs via the shared api-client.
 *
 * @module groupInboxConfigService
 */
import { api } from "@risalabs_frontend_org/api-client";
import { API_ENDPOINTS } from "../../../enums/apiUrls";
import {
  GroupInboxConfigRequest,
  GroupInboxConfigsResponse,
} from "./groupInboxConfigTypes";

/**
 * Service for reading Group Inbox configurations used by the medical oncology dashboard.
 */
export class GroupInboxConfigService {
  /**
   * Fetches the latest stored configuration for every eligible Group Inbox view tab.
   *
   * Bearer authentication is injected by {@link api.post}.
   *
   * @param payload - Organization id and optional `rpa` or `api` configuration route
   * @param signal - Optional abort signal for cancelling an in-flight request
   * @returns Response containing one version-keyed configuration per eligible view tab
   * @throws Error when authentication is missing or the HTTP request fails
   */
  static async getConfigurations(
    payload: GroupInboxConfigRequest,
    signal?: AbortSignal,
  ): Promise<GroupInboxConfigsResponse> {
    return api.post<GroupInboxConfigRequest, GroupInboxConfigsResponse>(
      API_ENDPOINTS.GROUP_INBOX_CONFIGS,
      payload,
      signal,
    );
  }
}
